// extracted by mini-css-extract-plugin
export default {"labelList":"LabelList_labelList__8MHgt","label":"LabelList_label__3yxCY"};